import { Column } from 'devextreme-react/data-grid';
import React, { useCallback, useState, useEffect } from 'react';
import { Button } from 'devextreme-react/button';
import { formatMessage } from 'devextreme/localization';
import columnDataGrid from './columnDataGrid';
import HeaderButtonMVP from '../../HeaderButtonMVP';
import DataGridMVP from '../../DataGridMVP';
import StornoCommentPopup from '../../StornoCommentPopup/StornoCommentPopup';
import ConfirmSkPopup from '../../ConfirmSkPopup/ConfirmSkPopup';
import useWasteColumns from '../../../hooks/useWasteColumns';

const FinishedProductConfirmation = ({
  selectedIndex,
  plantId,
  undercutReducer,
  getUndercutConfirmList,
  stornoUndercut,
  confirmUndercut,
  tabsReducer: { tabSelect },
  modalErrorOpen
}) => {
  const [
    selectedFinishedProductList,
    setSelectedFinishedProductList
  ] = useState([]);
  const [headerVisible, setHeaderVisible] = useState({ display: 'none' });
  const [stornoActive, setStornoActive] = useState(true);
  const [confirmationActive, setConfirmationActive] = useState(true);
  const [selectedUndercutData, setSelectedUndercutData] = useState([]);
  const [filterFinishedProduct, setFilterFinishedProduct] = useState({
    dateFrom: '',
    dateTo: ''
  });
  const [confirmPopupVisible, setConfirmPopupVisible] = useState(false);
  const [stornoPopupVisible, setStornoPopupVisible] = useState(false);
  const [comment, setComment] = useState('');
  const [dataGridInstance, setThisDataGridInstance] = useState(null);
  const [withWasteData, wasteColumns] = useWasteColumns(undercutReducer.undercutConfirmList);

  useEffect(() => {
    const selected = dataGridInstance
      ? dataGridInstance.props.dataSource.filter((el) =>
        dataGridInstance.props.selectedRowKeys.includes(el.finishedProductId))
      : [];
    const correctProduct = selected.every(
      (el) => el.cuttingPsStatusName === 'В наличии'
    );
    const createdProduct = selected.every(
      (el) => el.cuttingPsStatusName === 'Создан'
    );
    if (correctProduct && selectedUndercutData.length) {
      setStornoActive(false);
    } else {
      setStornoActive(true);
    }
    if (createdProduct && selectedUndercutData.length) {
      setConfirmationActive(false);
    } else {
      setConfirmationActive(true);
    }
  }, [selectedUndercutData, selectedFinishedProductList, dataGridInstance]);

  useEffect(() => {
    if (selectedUndercutData.length && selectedFinishedProductList.length) {
      setHeaderVisible({ display: 'flex', width: 'fit-content' });
    } else {
      setHeaderVisible({ display: 'none' });
    }
  }, [selectedUndercutData.length, selectedFinishedProductList.length]);

  const onSelectionChanged = useCallback(
    (selected) => {
      setSelectedUndercutData(selected.selectedRowsData);
      let selectedNew;
      if (
        selected.selectedRowKeys.length
        === undercutReducer.undercutConfirmList.length
      ) {
        selectedNew = selected.selectedRowKeys;
      } else if (
        selected.currentDeselectedRowKeys.length
        === undercutReducer.undercutConfirmList.length
      ) {
        selectedNew = [];
      } else if (selected.currentSelectedRowKeys[0]) {
        const selectedElement = undercutReducer.undercutConfirmList.find(
          (el) => el.finishedProductId === selected.currentSelectedRowKeys[0]
        );
        const { cuttingBatchId } = selectedElement;
        const sameElementsToCheck = undercutReducer.undercutConfirmList
          .filter((el) => el.cuttingBatchId === cuttingBatchId)
          .map((el) => el.finishedProductId);
        selectedNew = [
          ...selectedFinishedProductList,
          selectedElement.finishedProductId,
          ...sameElementsToCheck
        ];
      } else {
        selectedNew = selectedFinishedProductList.filter(
          (el) => el !== selected.currentDeselectedRowKeys[0]
        );
      }
      setSelectedFinishedProductList(selectedNew);
    },
    [selectedFinishedProductList, undercutReducer.undercutConfirmList]
  );

  const onCancelPopup = useCallback(() => {
    setConfirmPopupVisible(false);
    setStornoPopupVisible(false);
  }, []);

  const onConfirmationClick = () => {
    setConfirmPopupVisible(true);
  };

  const onConfirmUndercut = useCallback(() => {
    const cuttingProductIds = selectedUndercutData.map(
      (el) => el.cuttingPieceNumId
    );
    confirmUndercut(cuttingProductIds);
    onCancelPopup();
  }, [confirmUndercut, onCancelPopup, selectedUndercutData]);

  const onStornoClick = () => {
    setStornoPopupVisible(true);
  };

  const onStornoUndercut = useCallback(() => {
    const cuttingPieceIds = selectedUndercutData.map(
      (el) => el.cuttingPieceNumId
    );
    stornoUndercut({ cuttingPieceIds, comment });
  }, [comment, selectedUndercutData, stornoUndercut]);

  useEffect(() => {
    const { dateFrom, dateTo } = filterFinishedProduct;
    if (selectedIndex === 1) {
      getUndercutConfirmList({ plantId, dateFrom, dateTo });
    }
  }, [
    plantId,
    tabSelect,
    undercutReducer.undercutConfirm.okRequest,
    undercutReducer.undercutStorno.okRequest,
    filterFinishedProduct,
    selectedIndex,
    getUndercutConfirmList
  ]);

  // Обновление данных
  const onClickUpdate = useCallback(() => {
    getUndercutConfirmList({
      ...filterFinishedProduct,
      plantId
    });
  }, [filterFinishedProduct, getUndercutConfirmList, plantId]);

  return (
    <>
      <HeaderButtonMVP headButtVisibol={headerVisible}>
        <Button
          text={formatMessage('textButton').storno}
          type={'default'}
          stylingMode={'contained'}
          disabled={stornoActive}
          onClick={onStornoClick}
        />
        <Button
          text={formatMessage('textButton').confirm}
          type={'default'}
          stylingMode={'contained'}
          disabled={confirmationActive}
          onClick={onConfirmationClick}
        />
      </HeaderButtonMVP>
      <DataGridMVP
        dataSource={withWasteData}
        setDataGridInstance={setThisDataGridInstance}
        onSelectionChanged={onSelectionChanged}
        selectedRowKeys={selectedFinishedProductList}
        filterDataGrid={filterFinishedProduct}
        setFilterDataGrid={setFilterFinishedProduct}
        className="shipment"
        keyExpr="finishedProductId"
        setStateStoringName={'undercutConfirmationDataGrid'}
        dataGridOnOptionChanged={() => {}}
        tText={formatMessage('textPeriod')}
        visibleButtonDateRangePicker
        visibleInfoIcon={false}
        loadingData={undercutReducer.undercutConfirmListGet.loading}
        isDataLoading={undercutReducer.undercutConfirmListGet.loading}
        visibleGroupPanel={false}
        visibleActyalButton={false}
        visibleSummary
        onClickUpdate={onClickUpdate}
        visibleButtonQRCode={false}
        visibleButtonAddResponsiblePerson={false}
        visibleButtonCheckAll={false}
        visibleButtonUpdate
      >
        {columnDataGrid.map((item) => (
          <Column
            dataField={item.dataField}
            caption={item.caption}
            visible={!item.notVisible}
            allowSearch
            allowFiltering
            key={item.dataField}
            dataType={item.dataType}
            cssClass={item.cssClass}
            width={item.width ? item.width : undefined}
          />
        ))}
        {wasteColumns}
      </DataGridMVP>
      <ConfirmSkPopup
        visible={confirmPopupVisible}
        onHiding={onCancelPopup}
        qcIds={
          selectedUndercutData.length && selectedUndercutData.map((el) => el.cuttingQcId)
        }
        dates={
          selectedUndercutData.length
          && selectedUndercutData.map((el) => el.cuttingAccountingDate)
        }
        onConfirm={onConfirmUndercut}
        loading={undercutReducer.undercutConfirm.loading}
        okRequest={undercutReducer.undercutConfirm.okRequest}
      />
      <StornoCommentPopup
        visible={stornoPopupVisible}
        onHiding={onCancelPopup}
        comment={comment}
        setComment={setComment}
        onConfirm={onStornoUndercut}
        loading={undercutReducer.undercutStorno.loading}
        okRequest={undercutReducer.undercutStorno.okRequest}
        modalErrorOpen={modalErrorOpen}
      />
    </>
  );
};

export default React.memo(FinishedProductConfirmation);
